export type QuotationPaymentState = {
    paymentMethod: string;
    popup: {
        opened: boolean;
    };
    card: {
        payformConfiguration: {
            sessionKey: string;
            channel: string;
            merchantId: string;
            purchaseNumber: string;
            amount: number;
            callbackurl: string;
            language: string;
            font: string;
        };
        loading: boolean;
    };
};

export const quotationPaymentDefaultState: QuotationPaymentState = {
    paymentMethod: null,
    popup: {
        opened: false,
    },
    card: {
        payformConfiguration: {
            sessionKey: null,
            channel: "web",
            merchantId: null,
            purchaseNumber: null,
            amount: null,
            callbackurl: "",
            language: "es",
            font: "",
        },
        loading: false,
    },
};
